import IconPickerWithRemoveButton from 'client/components/core/Sidebar/components/Settings/components/IconPickerWithRemoveButton'
import HtmlAttrId from 'client/components/core/Sidebar/components/Settings/options/HtmlAttrId'
import React from 'react'
import { SidebarBottomPortal } from 'src/editor/layout/sidebar/settings/sidebar-bottom-portal'
import { CheckboxControl } from 'src/editor/shared/settings/checkbox-control'
import { TextInputControl } from 'src/editor/shared/settings/controls/text-input-control'
import { FormSubEntityTypeEnum } from 'src/shared/entities/form/enums'
import { FormInterface } from 'src/shared/entities/form/form.schema'
import { FormFieldInterface } from 'src/shared/entities/form/form-field-sub-entity.schema'
import { ContactSlugEnum } from 'src/shared/enums/contact-fields-enum'
import { useUpdateFormSubEntityProp } from '../../hooks/use-update-form-sub-entity-prop'
import { FormSubEntityCommonSettingsButtonLink } from './form-sub-entity-common-settings-button-link'

export const FormFieldSubEntitySettings = ({
  formEntity,
  fieldSubEntity,
}: {
  formEntity: FormInterface
  fieldSubEntity: FormFieldInterface
}) => {
  const updateProp = useUpdateFormSubEntityProp(formEntity, fieldSubEntity)

  const isMandatoryType = fieldSubEntity.slug === ContactSlugEnum.Email
  const isOptionalType =
    fieldSubEntity.slug === ContactSlugEnum.TaxNumber ||
    fieldSubEntity.slug === ContactSlugEnum.CompanyName

  const isOptionalSettingAvailable = !isMandatoryType && !isOptionalType

  return (
    <>
      {fieldSubEntity.slug !== ContactSlugEnum.Country &&
        fieldSubEntity.slug !== ContactSlugEnum.PhoneNumber && (
          <TextInputControl
            wrapperProps={{
              labelText: 'entity_settings.field.placeholder.label',
            }}
            value={fieldSubEntity.placeholder}
            update={updateProp('placeholder')}
            type="text"
          />
        )}
      {isOptionalSettingAvailable && (
        <CheckboxControl
          label="entity_settings.field.optional"
          tooltipText="entity_settings.field.optional_popover"
          value={fieldSubEntity.optional}
          update={updateProp('optional')}
        />
      )}
      {fieldSubEntity.slug !== ContactSlugEnum.Country && (
        <IconPickerWithRemoveButton
          label="entity_options.icon_picker.title"
          value={fieldSubEntity.iconClassName}
          update={updateProp('iconClassName')}
        />
      )}
      <HtmlAttrId attrId={fieldSubEntity.htmlAttrId} />

      <SidebarBottomPortal>
        <FormSubEntityCommonSettingsButtonLink
          formEntity={formEntity}
          commonSettingsType={FormSubEntityTypeEnum.Field}
        />
      </SidebarBottomPortal>
    </>
  )
}
